import React from 'react'
import { Link } from 'react-router-dom'
import MetisMenu from '@metismenu/react'
import 'metismenujs/dist/metismenujs.css'
import {
  AboutMenu,
  ServiceMenu,
  PlatformMenu,
  AITechMenu,
  ESGMenu,
  RecruitMenu,
} from '../../constants/siteMenus'

const MobileMenu = (props) => {
  const { onClick, active } = props

  return (
    <div className={`mobile-menu-wrapper ${active} d-lg-none`}>
      <div className="mobile-logo mb-5">
        <Link to="/" aria-label={'CODAM \uD648'}>
          <img src="/assets/img/logo/codam-logo.svg" alt={'CODAM \uB85C\uACE0'} style={{ maxHeight: '42px', width: 'auto' }} />
        </Link>
      </div>
      <div className="close-menu" onClick={onClick}>
        <i className="bi bi-x-lg"></i>
      </div>
      <div className="side-mobile-menu">
        <MetisMenu>
          <li className="has-dropdown">
            <a href="#">{'\uCF54\uB2F4\uC18C\uAC1C'}</a>
            <ul className="sub-menu">
              {AboutMenu.map((val, i) => (
                <li onClick={onClick} key={i}>
                  <Link to={val.routerPath}>{val.name}</Link>
                </li>
              ))}
            </ul>
          </li>
          <li className="has-dropdown">
            <a href="#">{'\uC11C\uBE44\uC2A4'}</a>
            <ul className="sub-menu">
              {ServiceMenu.map((val, i) =>
                val.children?.length ? (
                  <li className="has-dropdown" key={`svc-${i}`}>
                    <a href="#">{val.name}</a>
                    <ul className="sub-menu">
                      <li key={`svc-${i}-intro`}>
                        <Link onClick={onClick} to={val.routerPath}>코담디자인 소개</Link>
                      </li>
                      {val.children.map((c, j) => (
                        <li key={`svc-${i}-c-${j}`}>
                          <Link onClick={onClick} to={c.routerPath}>{c.name}</Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                ) : (
                  <li key={`svc-${i}`}>
                    <Link onClick={onClick} to={val.routerPath}>{val.name}</Link>
                  </li>
                ),
              )}
            </ul>
          </li>
          <li className="has-dropdown">
            <a href="#">{'\uD50C\uB7AB\uD3FC'}</a>
            <ul className="sub-menu">
              {PlatformMenu.map((val, i) => (
                <li onClick={onClick} key={i}>
                  <Link to={val.routerPath}>{val.name}</Link>
                </li>
              ))}
            </ul>
          </li>
          <li className="has-dropdown">
            <a href="#">{'AI\uAE30\uC220'}</a>
            <ul className="sub-menu">
              {AITechMenu.map((val, i) => (
                <li onClick={onClick} key={i}>
                  <Link to={val.routerPath}>{val.name}</Link>
                </li>
              ))}
            </ul>
          </li>
          <li className="has-dropdown">
            <a href="#">{'ESG'}</a>
            <ul className="sub-menu">
              {ESGMenu.map((val, i) => (
                <li onClick={onClick} key={i}>
                  <Link to={val.routerPath}>{val.name}</Link>
                </li>
              ))}
            </ul>
          </li>
          <li className="has-dropdown">
            <a href="#">{'\uCC44\uC6A9'}</a>
            <ul className="sub-menu">
              {RecruitMenu.map((val, i) => (
                <li onClick={onClick} key={i}>
                  <Link to={val.routerPath}>{val.name}</Link>
                </li>
              ))}
            </ul>
          </li>
          <li onClick={onClick}>
            <Link to="/contact">{'\uBB38\uC758\uD558\uAE30'}</Link>
          </li>
        </MetisMenu>
      </div>
      <div className="login-btn text-center mt-4">
        <Link className="theme_btn w-100" to="/login">Login</Link>
      </div>
    </div>
  )
}

export default MobileMenu
